import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import { useStateValue } from "../../context/StateProvider";

const gwadarCenter = {
  lat: 25.1264,
  lng: 62.3220,
};

const containerStyle = {
  width: "100%",
  height: "100%",
};

const Body = ({ action, setOrderOpen, setLocation }: { action: any, setOrderOpen: any, setLocation: any }) => {
  const apiKey = process.env.REACT_APP_MAPS_API_KEY || '';
  const [{ location }, dispatch] = useStateValue();

  const mapRef = useRef<google.maps.Map | null>(null);
  const [center, setCenter] = useState(gwadarCenter);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    
    const locationRaw = localStorage.getItem('location');
    const localLocation: string = locationRaw ? JSON.parse(locationRaw) : '';

    setCenter(localLocation || location || gwadarCenter);
  }, [location]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: apiKey,
  });

  const handleLoad = (map: google.maps.Map) => {
    mapRef.current = map;
  };

  const handleIdle = () => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      if (newCenter) {
        setCenter({
          lat: newCenter.lat(),
          lng: newCenter.lng(),
        });
      }
    }
  };

  const handleSetLocation = async () => {
    setLoading(true);
    // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${center.lat},${center.lng}&key=${apiKey}`;
    try {
      // const res = await fetch(url);
      // const data = await res.json();

      // if (data.status === "OK") {
      //   const address = data.results[0].formatted_address;
      //   dispatch({
      //     type: "SET_FORMATTED_LOCATION",
      //     formattedLocation: address,
      //   });
      // } else {
      //   console.error("Geocoding error:", data.status);
      // }

      dispatch({
        type: "SET_LOCATION",
        location: center,
      });

      localStorage.setItem('location', JSON.stringify(center));

      setLocation(center);
      setOrderOpen(true);
    } catch (error) {
      console.error("Fetch error:", error);
    }
    setLoading(false);
  };
  
  const handleMyLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const newCenter = { lat: latitude, lng: longitude };

        if (mapRef.current) {
          const currentCenter = mapRef.current.getCenter();
          if (!currentCenter) return;

          const startLat = currentCenter.lat();
          const startLng = currentCenter.lng();
          const endLat = newCenter.lat;
          const endLng = newCenter.lng;

          let frame = 0;
          const totalFrames = 30;
          const animate = () => {
            frame++;
            const progress = frame / totalFrames;

            const interpolatedLat = startLat + (endLat - startLat) * progress;
            const interpolatedLng = startLng + (endLng - startLng) * progress;

            mapRef.current?.panTo({ lat: interpolatedLat, lng: interpolatedLng });

            if (frame < totalFrames) {
              requestAnimationFrame(animate);
            }
          };

          animate();
        }

        setCenter(newCenter); // keep state in sync
      },
      (error) => {
        console.error("Error getting location:", error);
      }
    );
  } else {
    console.error("Geolocation not supported.");
  }
};


  return (
    <div className="w-full h-full flex flex-col">
      <div className="relative w-full h-[80%]">
     {!isLoaded ? (
  <div className="flex items-center justify-center h-full">
    <p className="text-gray-500">Loading map...</p>
    {/* Or use a spinner icon if you want */}
  </div>
) : (
  <>
    <GoogleMap
      onLoad={handleLoad}
      onIdle={handleIdle}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      options={{
        disableDefaultUI: true,
      }}
    />
    {/* Center Marker */}
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full z-10 pointer-events-none">
      <img
        src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
        alt="marker"
        className="w-10 h-10"
      />
    </div>

    {/* My Location Button */}
    <button
      onClick={handleMyLocation}
      className="absolute bottom-4 right-4 bg-white border border-gray-300 rounded-full shadow-md p-3 hover:bg-gray-100 z-20"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
        alt="My Location"
        className="w-5 h-5"
      />
    </button>
  </>
)}

      </div>

      {/* Set Location Button */}
      <div className="h-[20%] flex items-center justify-center">
        <button
          onClick={handleSetLocation}
          className="px-6 py-3 bg-redPrimary text-white font-semibold rounded-lg shadow-lg hover:bg-red-700 transition duration-300 flex items-center justify-center gap-2"
          disabled={loading}
        >
          {loading ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          ) : (
            "Set Location"
          )}
        </button>
      </div>
    </div>
  );
};

export default Body;
